import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";

import { checkEmpanelementStatus } from "../../../../../store/actions/nps";

import { POP_LIST } from "../../";

const IS_ACTIVE = 3001;

const useEmpanelment = (agentReferenceNumber) => {
  const dispatch = useDispatch();

  const [popDetails, setPopDetails] = useState({
    popCode: "",
    popSpCode: "",
  });

  const fetchEmpanelmentDetails = useCallback(async () => {
    const fetchEmpanelmentStatus = async (params) => {
      const response = await dispatch(checkEmpanelementStatus(params));
      if (parseInt(JSON.parse(response.body).Code) === IS_ACTIVE) return true;
      return false;
    };

    POP_LIST.forEach(async (pop) => {
      const params = {
        AgentReferenceNumber: agentReferenceNumber,
        POP_Code: pop.popCode,
        POP_SP_Code: pop.popSpCode,
      };

      const isEmpanelled = await fetchEmpanelmentStatus(params);

      isEmpanelled &&
        setPopDetails({ popCode: pop.popCode, popSpCode: pop.popSpCode });
    });
  }, [dispatch, agentReferenceNumber]);

  useEffect(() => {
    !!agentReferenceNumber && fetchEmpanelmentDetails();
  }, [fetchEmpanelmentDetails, agentReferenceNumber]);

  return popDetails;
};

export default useEmpanelment;
